import { createTheme, PaletteMode } from '@mui/material';
import { itIT } from '@mui/material/locale';
import { itIT as itGrid } from '@mui/x-data-grid-premium';
import { isTablet } from 'react-device-detect';
import type {} from '@mui/x-data-grid-premium/themeAugmentation';

export function getBludataTheme(themeMode: PaletteMode) {
  return createTheme(
    {
      palette: {
        mode: themeMode,
        primary: {
          main: '#1375c0',
          light: '#bbdefb',
          dark: '#1976d2',
        },
        error: {
          main: '#bc3c44', // colore ext        },
        },
      },
      typography: {
        allVariants: {
          color: 'var(--color)',
        },
        button: {
          textTransform: 'none',
          fontSize: '16px',
          fontWeight: '600',
          letterSpacing: 'none',
        },
      },
      components: {
        MuiDataGrid: {
          styleOverrides: {
            cell: {
              outline: 'none!important',
            },
          },
          defaultProps: {
            density: 'compact',
            localeText: {
              ...itGrid?.components?.MuiDataGrid?.defaultProps?.localeText,
              noRowsLabel: 'Nessun dato disponibile',
              footerTotalRows: 'Righe totali: ',
              MuiTablePagination: {
                ...itGrid?.components?.MuiDataGrid?.defaultProps?.localeText
                  ?.MuiTablePagination,
                labelDisplayedRows: ({ from, to }) => `${from} - ${to}`,
              },
            },
          },
        },
        MuiButton: {
          styleOverrides: {
            root: ({ ownerState, theme }) => {
              const defaultOverride = {
                padding: isTablet ? '0px 8px' : '3px 16px',
                justifyContent: 'start',
              };
              if (
                ownerState.variant === 'outlined' &&
                theme.palette.mode === 'dark'
              ) {
                return {
                  ...defaultOverride,
                  color: 'white',
                };
              }
              return defaultOverride;
            },
          },
          defaultProps: {
            variant: 'contained',
            disableElevation: true,
          },
        },
        MuiIconButton: {
          styleOverrides: {
            root: ({ theme }) => {
              if (theme.palette.mode === 'dark') {
                return {
                  color: 'white',
                };
              }
              return {};
            },
          },
        },
        MuiPaper: {
          styleOverrides: {
            root: {
              backgroundColor: 'var(--base-foreground-color)',
            },
          },
        },
        MuiDialog: {
          defaultProps: {
            disableAutoFocus: true,
            disableEnforceFocus: true,
            disableRestoreFocus: true,
            fullScreen: isTablet,
            PaperProps: {
              autoComplete: 'new-password', // Imposta l'autocomplete per tutti i dialog come form
            },
          },
          styleOverrides: {
            paper: {
              backgroundColor: 'var(--background-color) !important',
              backgroundImage: 'none!important',
            },
          },
        },
        /*        Tema dialog sencha*/ MuiDialogTitle: {
          styleOverrides: {
            root: {
              backgroundColor: 'var(--base-color)',
              color: 'var(--reverse-color)',
              marginBottom: '10px',
              padding: '12px 16px',
              lineHeight: '1.3em',
            },
          },
        },
        MuiTabs: {
          styleOverrides: {
            root: {
              minHeight: 'unset !important',
              '& .MuiTab-root': {
                borderBottom: '1px solid var(--base-color)',
                minHeight: 'unset !important',
                padding: '8px 16px !important',
              },
              '& .MuiTabs-flexContainer': {
                alignItems: 'end',
              },
              '& .MuiTabs-flexContainer:after': {
                content: '""',
                height: '1px',
                backgroundColor: 'var(--base-color)',
                flex: 1,
              },
              '& .Mui-selected': {
                border: '1px solid var(--base-color)',
                borderTopLeftRadius: '4px',
                borderTopRightRadius: '4px',
                borderBottom: '0px solid',
                color: 'var(--base-color) !important',
              },
            },
            indicator: {
              display: 'none',
            },
          },
        },
        MuiTextField: {
          defaultProps: {
            variant: 'standard',
            autoComplete: 'new-password',
          },
        },
        MuiTypography: {
          defaultProps: {
            variant: 'body2',
          },
        },
        MuiSelect: {
          defaultProps: {
            variant: 'standard',
          },
        },
        MuiFormControlLabel: {
          styleOverrides: {
            label: {
              color: 'var(--color)',
              fontSize: '0.875rem !important',
            },
          },
        },
        MuiInputBase: {
          defaultProps: {
            size: 'small',
            autoComplete: 'new-password',
          },
          styleOverrides: {
            root: {
              marginTop: '0px !important',
              border: '1px solid #a0c7e5',
              borderRadius: '4px',
              paddingLeft: '5px',
              paddingTop: '2px',
              paddingRight: '5px',
              fontWeight: 'bold',
              ':before': {
                opacity: '0',
              },
            },
          },
        },
        MuiInputLabel: {
          styleOverrides: {
            root: {
              transform: 'none !important',
              color: 'var(--color) !important',
              position: 'relative',
              fontSize: '0.875rem',
            },
          },
        },
        MuiAutocomplete: {
          defaultProps: {
            autoHighlight: true,
          },
        },
      },
    },
    itIT
  );
}
